module.exports = __webpack_public_path__ + "img/img_baby_app_2_ko.34c76d98.png";